+function($, window, document) {
	'use strict';
	
	//init scope
	var scope;
	
	//constructor
	var PopupCart = function(element, options) {
		scope = this;
		
		this.options = options;
		this.$element = $(element);
		this.$document = $(document.body);
		this.$content = this.$element.find('dd');
		this.isTouch = false;
		
		this.initialize();
	};
	
	PopupCart.DEFAULTS = {
	};
	
	PopupCart.prototype.initialize = function() {
		this.detectDevice();
		this.observeTrigger();
		this.subscribe();
		
		//close the popup cart in the pc automatically
		if ( ! this.isTouch) {
			this.autoClose();
		}
		
	};
	
	PopupCart.prototype.detectDevice = function() {
		if ($(window).width() < 992) {
			this.isTouch = true;
			
			this.$content.css('width', this.$element.width());
		}else {
			this.$content.css('width', this.$element.width() - 1);
		}
	};
	
	PopupCart.prototype.subscribe = function() {
		$.subscribe('refresh-cart', this.refreshCart)
	};
	
	PopupCart.prototype.refreshCart = function() {
		var countItems = 0;
		
		$.get('/cart/refresh').done(function(cartContent) {
			scope.$content.empty().append(cartContent).toggle();
			
			countItems = scope.$content.find('tr').length - 1;
			
			scope.$element.find('dt').empty().append('<i class="icon-shopping-cart icon-large"></i> Cart (' + countItems + ')');
		});
	};
	
	PopupCart.prototype.observeTrigger = function() {
		if (this.isTouch) {
			//disable click cart link in the mobile
			this.$element.on('click', 'dt a', function(event) {
				event.preventDefault();
				
				return false;
			});
			
			var cart = this.$element.find('dt a');
			var hammer = new Hammer(cart[0]);
			
			hammer.on('tap', function(event) {
				scope.$content.toggle();
			});
		}else {
			this.$element.on('mouseover', function(event) {
				scope.$content.show();
				
				return false;
			});
			
			this.$element.on('mouseleave', function() {
				scope.$content.hide();
				
				return false;
			});
		}
	};
	
	PopupCart.prototype.autoClose = function() {
		this.$document.on('click', function(event) {
			if (!$(event.target).is('#cart-menu')) {
				if (scope.$content.css('display') != 'none') {
					scope.$content.toggle();
				}
			}
		});
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.PopupCart'),
    			options = $.extend({}, PopupCart.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.PopupCart', (data = new PopupCart(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.PopupCart;
	
	$.fn.PopupCart = Plugin;
	$.fn.PopupCart.Constructor = PopupCart;
	
	$.fn.PopupCart.noConflict = function () {
	    $.fn.PopupCart = old;
	    return this;
	};
}(jQuery, window, document);